import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { MaterialModule } from 'src/app/shared';
import { Safe } from 'src/app/core/pipes/safe';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { Notfound404Component } from './notfound404/notfound404.component';
import { RouterStateSnapshot } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Forbidden403Component } from './forbidden403/forbidden403.component';
import { CalendarModule } from 'angular-calendar';
import { ShipmentsComponent } from './shipments/shipments.component';
import { AddEditShipmentComponent } from './shipments/add-edit-shipment/add-edit-shipment.component';
import { ViewShipmentComponent } from './shipments/view-shipment/view-shipment.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RateSetupComponent } from './rate-setup/rate-setup.component';
import { AddEditRatesComponent } from './rate-setup/add-edit-rates/add-edit-rates.component';
import { SaleOrderComponent } from './sale-order/sale-order.component';
import { ReportComponent } from './report/report/report.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductComponent } from './product/product.component';
import { AddEditProductComponent } from './product/add-edit-product/add-edit-product.component';

@NgModule({
  declarations: [MainComponent,ReportComponent, Safe, Notfound404Component, Forbidden403Component, ShipmentsComponent, ViewShipmentComponent,AddEditShipmentComponent, RateSetupComponent, AddEditRatesComponent, SaleOrderComponent, ProductComponent, AddEditProductComponent],
  imports: [
    CommonModule,
    MainRoutingModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CalendarModule,
    PdfViewerModule,
    NgbModule
    

  ],
  entryComponents: [
  ],
  providers: [
    AuthGuard,
    DatePipe
  ]
})
export class MainModule { }
